import { IconDashboard, IconKey, IconChartLine, IconHome, IconCalendarWeek, IconReport, IconUserCircle } from '@tabler/icons-react';
import NotificationsActiveIcon from '@mui/icons-material/NotificationsActive';
import NotificationsActiveOutlinedIcon from '@mui/icons-material/NotificationsActiveOutlined';
import { IconBellRinging } from '@tabler/icons-react';
import AccountCircleOutlinedIcon from '@mui/icons-material/AccountCircleOutlined';
import BarChartIcon from '@mui/icons-material/BarChart';
import DonutSmallOutlinedIcon from '@mui/icons-material/DonutSmallOutlined';

//คำขอ
import SendIcon from '@mui/icons-material/Send';
import AssignmentIcon from '@mui/icons-material/Assignment';
import ListAltIcon from '@mui/icons-material/ListAlt';
import ForwardToInboxIcon from '@mui/icons-material/ForwardToInbox';
import ReceiptIcon from '@mui/icons-material/Receipt';
import BatchPredictionIcon from '@mui/icons-material/BatchPrediction';
import LockIcon from '@mui/icons-material/Lock';
import GroupIcon from '@mui/icons-material/Group';
import AutoStoriesIcon from '@mui/icons-material/AutoStories';
import PersonIcon from '@mui/icons-material/Person';
import VolumeUpIcon from '@mui/icons-material/VolumeUp';
import ContentPasteIcon from '@mui/icons-material/ContentPaste';

import { BsFileEarmarkBarGraph } from 'react-icons/bs';
const FileEarmark = () => <BsFileEarmarkBarGraph />;
// constant
const icons = {
  SendIcon,
  DonutSmallOutlinedIcon,
  IconDashboard,
  IconKey,
  BarChartIcon,
  NotificationsActiveIcon,
  NotificationsActiveOutlinedIcon,
  AccountCircleOutlinedIcon,
  IconChartLine,
  AutoStoriesIcon,
  VolumeUpIcon,
  PersonIcon,
  FileEarmark,
  ContentPasteIcon,
  IconHome,
  IconCalendarWeek,
  IconReport,
  IconUserCircle
};
// ==============================|| DASHBOARD MENU ITEMS ||============================== //

const dashboard = {
  id: 'dashboard/default',
  type: 'group',
  children: [
    {
      id: 'default',
      title: 'หน้าหลัก',
      type: 'item',
      url: '/student/main-menu',
      icon: IconHome,
      breadcrumbs: false
    },

    {
      id: 'default',
      title: 'ระบบการลา',
      type: 'item',
      url: '/student/leav',
      icon: IconCalendarWeek,
      breadcrumbs: false
    },
    {
      id: 'default',
      title: 'บันทึกการมาเรียน',
      type: 'item',
      url: '/student/atten',
      icon: IconReport,
      breadcrumbs: false
    },
    {
      id: 'notification',
      title: 'ระบบการแจ้งเตือน',
      type: 'item',
      url: '/student/student_notification',
      icon: NotificationsActiveOutlinedIcon,
      breadcrumbs: false
    },
    ,
    // {
    //   id: 'request',
    //   title: 'Request',
    //   type: 'collapse',
    //   icon: AssignmentIcon,
    //   children: [
    //     {
    //       id: 'Request1',
    //       title: 'TRequest1',
    //       type: 'item',
    //       url: '/request/tef',
    //       icon: ListAltIcon
    //     },
    //     {
    //       id: 'Request2',
    //       title: 'Request2',
    //       type: 'item',
    //       url: '/request/fei',
    //       icon: ListAltIcon
    //     },
    //     {
    //       id: 'Request3',
    //       title: 'VRequest3',
    //       type: 'item',
    //       url: '/request/veterinarian',
    //       icon: ListAltIcon
    //     }
    //   ]
    // },

    {
      id: 'account',
      title: 'ระบบข้อมูลส่วนตัว',
      type: 'item',
      url: 'student/account/index',
      icon: IconUserCircle,
      breadcrumbs: false
    }
  ]
};

export default dashboard;
